import React, { Component } from 'react';
import { connect } from 'react-redux';

import { filterCompaniesByTypeDispatch } from '../actions';

class FilterTypes extends Component {
	constructor() {
		super();
		this.types = [
			{ 'name': 'All', 'icon': 'glyphicon glyphicon-globe' },
			{ 'name': 'Primary', 'icon': 'glyphicon glyphicon-king' },
			{ 'name': 'Associate', 'icon': 'glyphicon glyphicon-queen'},
			{ 'name': 'Subscriber', 'icon': 'glyphicon glyphicon-bishop' }];
	}

	componentWillMount() {
		if ( this.props.memberType === '' ) {
			this.props.memberType = 'all';
		}
	}

	handleClick( event ) {
		let type = event.target.getAttribute( 'data-type' );
		this.props.filterCompaniesByTypeDispatch( type );
	}

	setClassName( type ) {
		let classes = '';
		if ( this.props.memberType === type ) {
			classes += ' active-tab-indicator';
		}

		return classes;
	}

	getHeaders() {
		return this.types.map( type => {
			return (<div role="presentation"
			             className={ 'headers-main-tab ' + this.setClassName( type.name.toLowerCase() ) } data-type={ type.name.toLowerCase() }>
					<h4 data-type={ type.name.toLowerCase() }
					    onClick={ this.handleClick.bind( this ) }
					    data-type={ type.name.toLowerCase() }>
						<span className={ type.icon } aria-hidden="true"/>
						{ type.name } Members
					</h4>
				</div>
			);
		} );
	}

	renderTabs() {
		return this.types.map( type => {
			return (
				<div role="presentation" className={"text-center tab-indicator " + this.setClassName( type.name.toLowerCase() ) } onClick={ this.handleClick.bind( this ) } data-type={ type.name.toLowerCase() }></div>
			);
		} );
	}

	render() {
		return (<div id="member-list-filters" className="container">
				<div className="main-tab-container">
					{ this.getHeaders() }
				</div>
				<div className="tab-indicator-container">
					{ this.renderTabs() }
				</div>
			</div>
		);
	}
}

function mapStateToProps( { memberType } ) {
	return { memberType };
}

export default connect( mapStateToProps, {
	filterCompaniesByTypeDispatch
} )( FilterTypes );